import React, { useEffect, useState } from "react";
import PageNavBar from "../Component/page/PageNavBar";
import { useDispatch, useSelector } from "react-redux";
import {
  selectMember,
  setUserEmail,
  setUserSubId,
} from "../features/member/slice";
import Dashboard from "../Component/Dashboard";
import { withAuthenticator } from "@aws-amplify/ui-react";
import { DataStore } from "aws-amplify";
import { setMember } from "../features/member/slice";
import { Member, Chapter } from "../models";
import { setEditMember } from "../features/edit/slice";
import { isEmpty } from "lodash";
import { selectChapterId, setChapter } from "../features/chapter/slice";
import parseModel from "../util/parseModel";

function DashboardPage({ user }) {
  const chapterID = useSelector(selectChapterId);
  const member = useSelector(selectMember);
  const dispatch = useDispatch();

  //set user
  useEffect(() => {
    dispatch(setUserSubId(user?.attributes?.sub));
    dispatch(setUserEmail(user?.attributes?.email));
  }, [chapterID]);

  // get member and chapter
  useEffect(() => {
    const member = DataStore.observeQuery(Member, (student) =>
      student.email.eq(user.attributes.email)
    ).subscribe(({ items }) => {
      const foundStudent = getMemberByChapterId(items, chapterID);
      if (!isEmpty(foundStudent)) {
        dispatch(setMember(foundStudent));
        dispatch(setEditMember(foundStudent));
      }
    });

    const chapters = DataStore.observeQuery(Chapter, (chapter) =>
      chapter.chapterOpen.eq(true)
    ).subscribe(({ items }) => {
      const data = parseModel(items[0]);
      if (!isEmpty(data)) {
        dispatch(setChapter(data));
      }
    });

    return () => {
      member.unsubscribe();
      chapters.unsubscribe();
    };
  }, [user, chapterID]);

  return (
    <div>
      <PageNavBar />
      {member && <Dashboard data={member} />}
      {!member && <p>Member not found. Pease signup</p>}
    </div>
  );
}

export default withAuthenticator(DashboardPage);

function getMemberByChapterId(members, chapterID) {
  for (let i = 0; i < members.length; i++) {
    var member = parseModel(members[i]);
    if (member.chapterID === chapterID) {
      return member;
    }
  }
  return {};
}

function getOpenChapter(chapters) {
  for (let i = 0; i < chapters.length; i++) {
    var chapter = parseModel(chapters[i]);
    if (chapter.chapterOpen) {
      return chapter;
    }
  }
  return {};
}
